export default __webpack_public_path__ + "static/media/suppliment_yellow.bee436b2.svg";